import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER } from '@angular/core';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { FlotModule } from 'ng2modules-flot';
import { ChartsModule } from 'ng2-charts';
import { ParticlesModule } from 'angular-particle';
import {TableModule} from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import {CalendarModule} from 'primeng/calendar';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {InputSwitchModule} from 'primeng/inputswitch';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './auth/login/login.component';
import {HttpClientModule} from '@angular/common/http';
import { LayoutComponent } from './layout/layout.component';
import { LibdashComponent } from './libdash/libdash.component';
import { BooksComponent } from './books/books.component';
import { MembersComponent } from './members/members.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WebcamModule } from 'ngx-webcam';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ElinksComponent } from './elinks/elinks.component';

import { AppGlobals } from './shared/app.global';
import { ConfigService } from './config.service';
import { environment } from '../environments/environment';
import * as hammer from 'hammerjs';
import { NgxImageGalleryModule } from 'ngx-image-gallery';


// import {
//   MatAutocompleteModule,



// } from '@angular/material/autocomplete';
// import {
//   MatSelectModule,



// } from '@angular/material/select';
// import {MatInputModule} from '@angular/material/input';
// import { MatIconModule } from '@angular/material/icon';

import { LibmasterComponent } from './libmasters/libmasters.component';
import { BookissueComponent } from './bookissue/bookissue.component';
import { VisitrecordComponent } from './visitrecord/visitrecord.component';

import { EnquiryComponent,AdmissionComponent,PgenquiryComponent,SmsComponent } from './frontoffice/index';
import { AcademicmasComponent,CurriculammasComponent,AcfeechartComponent,AccmasterComponent,AssessmentComponent } from './masters/index';

import { StuallotComponent } from './mentor/stuallot/stuallot.component';
import { AssignactComponent } from './mentor/assignact/assignact.component';
import { ReviewactComponent } from './mentor/reviewact/reviewact.component';

import { AttperiodComponent,AttsessionComponent,AttpertimeComponent,AttreportComponent } from './attendance/index';
import { FeedmasterComponent } from './feedback/feedmaster/feedmaster.component';
import { FbqttypemasComponent } from './feedback/fbqttypemas/fbqttypemas.component';
import { FbqtbankComponent } from './feedback/fbqtbank/fbqtbank.component';
import { FeedbackprevComponent } from './feedback/feedbackprev/feedbackprev.component';
import {AssessmentschComponent,HolidaysComponent,YearCalenderComponent,TimetableComponent,SmsmarksComponent} from './schedules/index';
import { LibperiodicalsComponent } from './libperiodicals/libperiodicals.component';
import { AstmstrComponent,ItemmstrComponent,AsetmastersComponent } from './inventory/index';
import { MarkssubComponent ,MarksstuComponent,LabvisitComponent} from './classroom/index';
import { AcreceiptComponent } from './feecounter/acreceipt/acreceipt.component';
import { StockauditComponent } from './stockaudit/stockaudit.component';
import {BookresvComponent,ReferredbooksComponent,EbooksComponent,OpacComponent,BookindentComponent,AprvindentComponent,CirculationComponent,LibmembersComponent  } from './library/index';
import { HrmastersComponent } from './hrms/hrmasters/hrmasters.component';
import { OccationsComponent } from './schedules/occations/occations.component';
import { NodoubleclickDirective } from './directives/nodoubleclick.directive';
import { AssignmentComponent } from './classroom/assignment/assignment.component';
import { NotificationsComponent } from './schedules/notifications/notifications.component';
import { RolesComponent } from './security/roles/roles.component';
import { LogsComponent } from './security/logs/logs.component';
import { CandidateComponent,PostsComponent,CompanyComponent,PladashComponent,PlanotificationsComponent } from './placement/index';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EmploysComponent } from './hrms/employs/employs.component';
import { InsjobpostComponent } from './placement/insjobpost/insjobpost.component';
import { EvpatternComponent } from './evaluation/evpattern/evpattern.component';
import { MarksgenComponent } from './classroom/marksgen/marksgen.component';
import { RoomallocationComponent } from './evaluation/roomallocation/roomallocation.component';
import { UsersComponent } from './security/users/users.component';
import { ReportcardComponent } from './evaluation/reportcard/reportcard.component';
import { AdmitcardComponent } from './evaluation/admitcard/admitcard.component';
import { WorkdairyComponent } from './hrms/workdairy/workdairy.component';
import { GeneratefeesComponent } from './feecounter/generatefees/generatefees.component';
import { ResourcesComponent } from './classroom/resources/resources.component';
import { ItemqrcodeComponent } from './inventory/itemqrcode/itemqrcode.component';
import { WorksheetComponent } from './classroom/worksheet/worksheet.component';
import { EventgallaryComponent } from './classroom/eventgallary/eventgallary.component';
import { EvlmasterComponent } from './evaluation/evlmaster/evlmaster.component';
import { ResultsComponent } from './evaluation/results/results.component';
import { QuestionbankComponent } from './evaluation/questionbank/questionbank.component';
import { QuestpaperComponent } from './evaluation/questpaper/questpaper.component';
import { QpallotmentComponent } from './evaluation/qpallotment/qpallotment.component';
import { RemarkentryComponent } from './classroom/remarkentry/remarkentry.component';
import { VtcandidateComponent } from './voting/candidate/candidate.component';
import { VotersComponent } from './voting/voters/voters.component';
//import { SmsmarksComponent } from './schedules/smsmarks/smsmarks.component';
//import {  } from './attendance/attreport/attreport.component';




//import {  } from './library/aprvindent/aprvindent.component';








@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    DashboardComponent,
    HomeComponent,
    LoginComponent,
    LayoutComponent,
    LibdashComponent,
    BooksComponent,
    MembersComponent,
    LibmasterComponent,
    BookissueComponent,
    VisitrecordComponent,
    EnquiryComponent,
    AdmissionComponent,
    AcademicmasComponent,
    CurriculammasComponent,
    AssessmentComponent,
    StuallotComponent,
    AssignactComponent,
    ReviewactComponent,
    AttsessionComponent,
    AttperiodComponent,
    AttpertimeComponent,
    FeedmasterComponent,
    FbqttypemasComponent,
    FbqtbankComponent,AssessmentschComponent,HolidaysComponent,YearCalenderComponent,
    FeedbackprevComponent,
    LibperiodicalsComponent,
    PgenquiryComponent,SmsComponent,ElinksComponent,AstmstrComponent,ItemmstrComponent, AsetmastersComponent, MarkssubComponent, MarksstuComponent, AcreceiptComponent, StockauditComponent,
    BookresvComponent,ReferredbooksComponent, EbooksComponent, LabvisitComponent, HrmastersComponent, OccationsComponent,OpacComponent, AcfeechartComponent,
    AccmasterComponent,AssessmentComponent,
    NodoubleclickDirective,
    AssignmentComponent,
    NotificationsComponent,
    BookindentComponent,
    AprvindentComponent,
    RolesComponent,
    LogsComponent,
    CandidateComponent,
    PostsComponent,PlanotificationsComponent,TimetableComponent,
    CompanyComponent,CompanyComponent, EmploysComponent, PladashComponent, CirculationComponent, LibmembersComponent, InsjobpostComponent, EvpatternComponent, MarksgenComponent, AttreportComponent, SmsmarksComponent, RoomallocationComponent, UsersComponent, ReportcardComponent, AdmitcardComponent, WorkdairyComponent, GeneratefeesComponent, ResourcesComponent, ItemqrcodeComponent, WorksheetComponent, EventgallaryComponent, EvlmasterComponent, ResultsComponent, QuestionbankComponent, QuestpaperComponent, QpallotmentComponent, RemarkentryComponent, VtcandidateComponent, VotersComponent
    
   
  
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatSlideToggleModule,
    FlotModule,
    ChartsModule,
    TableModule,
    DropdownModule,
    NgbModule,
    CalendarModule,
    AutoCompleteModule,
    InputSwitchModule,
    InputTextareaModule,
    ParticlesModule,
    NgSelectModule,
    PdfViewerModule,NgxImageGalleryModule,
    WebcamModule,NgMultiSelectDropDownModule.forRoot()
    // MatAutocompleteModule,
    // MatSelectModule,MatInputModule,MatIconModule
   
 
  ],
  providers: [AppGlobals],
  bootstrap: [AppComponent]
})
export class AppModule { }
